module.exports = __webpack_public_path__ + "img/nav-right-expand-search-v2.51050a6d.png";